import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../Button/Button";
import Input from "../Input/Input";
import logo from "../assets/logo.png";

function RegisterForm() {
  const navigate = useNavigate();
  const [form, setForm] = React.useState({
    name: "",
    gender: "",
  });

  const onClick = async () => {
    if (form.name === "" || form.gender === "") {
      toast("Please fill both name and gender fields");
      return;
    }

    navigate("/camera", {
      state: {
        name: form.name,
        gender: form.gender,
      },
    });
  };

  const onChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // const handleKeyboardChange = (input) => {
  //   if (activeInput === "mobile" && input.length > 10) return;
  //   setForm((prevFormData) => ({
  //     ...prevFormData,
  //     [activeInput]: input,
  //   }));
  // };

  return (
    <div className="flex flex-col h-full">
      <div
        className="flex justify-center font-bold text-white py-14 text-center"
        onClick={() => navigate("/")}
        style={{ cursor: "pointer" }}
      >
        <img src={logo} alt="" />
      </div>
      <div className="card gradient">
        <h1 className="text-4xl text-center text-[#1E5898] w-full capitalize sm:text-5xl md:text-5xl lg:text-5xl">
          REGISTER
        </h1>
        <Input
          label="Name"
          placeholder="Enter your name"
          name="name"
          value={form.name}
          onChange={onChange}
          // onClick={() => setActiveInput("name")}
        />
        <Input
          label="Gender"
          placeholder="Enter your Gender"
          name="gender"
          value={form.gender}
          onChange={onChange}
          // onClick={() => setActiveInput("name")}
        />

        <Button label="NEXT" onClick={onClick} />
      </div>
      {/* <div
        style={{
          position: "absolute",
          width: "100%",
          bottom: 500,
          height: "20vh",
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      > */}
      {/* {activeInput !== "" && (
          <div style={{ width: "80%" }}>
            <Keyboard
              layout={{
                default: [
                  "1 2 3 4 5 6 7 8 9 0 {bksp}",
                  "q w e r t y u i o p ",
                  "a s d f g h j k l ; '",
                  "z x c v b n m , . /",
                  "! @ # $ % ^ & * ( ) _ +",
                  ".com {space}",
                ],
              }}
              onChange={handleKeyboardChange}
              inputName={activeInput}
            />
          </div>
        )} */}
      {/* </div> */}
    </div>
  );
}

export default RegisterForm;
